// Сохранения форм основной системы, у которых кнопка блокируется на время запроса и которые
// сообщают человеку, если запрос не удался. Имя сохранения это имя типа действия без суффикса
// _REQUEST / _SUCCESS / _FAILURE и без имени модуля (COMPANIES/COMPANY_CREATE_REQUEST → COMPANY_CREATE).
// Загрузки списков и удаления сюда не входят: у них своё поведение.
export const SAVES = [
  'COMPANY_CREATE',
  'COMPANY_EDIT',
  'NORIFICATION_MEMO_CREATE', // так написано в типах Companies
  'NOTIFICATION_CREATE_OR_UPDATE',
  'MONITOR_CREATE',
  'MONITOR_EDIT',
  'PRODUCT_TYPE_CREATE',
  'PRODUCT_CREATE',
  'PRODUCT_EDIT',
];

const PATTERN = /\/([A-Z_]+)_(REQUEST|SUCCESS|FAILURE)$/;

// { name, stage } для типа действия-сохранения, иначе null.
export const saveOf = (type) => {
  const found = typeof type === 'string' ? PATTERN.exec(type) : null;
  return found && SAVES.includes(found[1]) ? { name: found[1], stage: found[2] } : null;
};

// Идёт ли сейчас хоть одно из названных сохранений. root это срез store основной части (ROOT);
// store без него (тесты отдельных форм) значит «ничего не сохраняется».
export const isSaving = (root, ...names) => names.some((name) => Boolean(root && root.saving && root.saving[name]));

// То, что видит человек, когда сохранение не удалось, а само сохранение ничего не сказало.
export const GENERIC_SAVE_ALERT = {
  show: true,
  alertTitle: 'Не удалось сохранить',
  alertText: 'Попробуйте ещё раз.',
  severity: 'error',
  style: {},
  variant: 'outlined',
};
